<template>
  <div>
    <div class="hw_wrap" v-if="!$route.meta.basicLayout">
      <MainHeader />
      <div class="main_wrap">
        <MainLeft />
        <div class="main_container">
          <div class="main_contents">
            <router-view></router-view>
            <MainFooter v-if="!$route.meta.okrFooter" />
          </div>
        </div>
      </div>
    </div>
    <div class="hw_wrap" v-if="$route.meta.basicLayout">
      <router-view />
    </div>
    <!-- <modals-container @returnAgreement="returnAgreement"/> -->
  </div>
</template>
<script>
import MainHeader from "@/components/cowork/general/main/MainHeader";
import MainFooter from "@/components/cowork/general/main/MainFooter";
import MainLeft from "@/components/cowork/general/main/MainLeft";
export default {
  data() {
    return {
      path : "",
    }
  },
  components : {
    MainHeader,
    MainFooter,
    MainLeft
  },
};
</script>



// WEBPACK FOOTER //
// src/components/cowork/cosys/Index.vue